// extracted by mini-css-extract-plugin
export default {"aboutMeBlock":"About_aboutMeBlock__AEsHA","story":"About_story__rfDQM"};